import type { Action } from "@reduxjs/toolkit";

export type IdAction = Action<"ID"> & { payload: number }

export const IdReducer = (state= 0, action: IdAction) => {
    if (action.type === "ID") {
        return action.payload;
    }
    return state;
}